/**
 * Builds query args for admin-v2 "settings" list endpoints with optional org scoping.
 *
 * @remarks
 * The UI accepts a free-form organisation id filter. We trim it and omit `organisationId`
 * entirely when empty so callers never accidentally send `organisationId: ""` (which would
 * be ambiguous and may fail backend validation).
 *
 * `includeGlobal` only applies when an organisation scope is set: when no org is provided,
 * we omit it to avoid conflating "global only" vs "org + global" behaviors.
 */
export const buildSettingsScopeQueryArgs = (args: {
  organisationIdFilter: string;
  includeGlobal: boolean;
  limit: number;
}): {
  organisationId?: string;
  includeGlobal?: boolean;
  limit: number;
} => {
  const scopedOrganisationId = args.organisationIdFilter.trim();
  const hasScopedOrganisationFilter = scopedOrganisationId.length > 0;

  return {
    ...(hasScopedOrganisationFilter
      ? { organisationId: scopedOrganisationId }
      : {}),
    ...(hasScopedOrganisationFilter
      ? { includeGlobal: args.includeGlobal }
      : {}),
    limit: args.limit,
  };
};
